import { useSelector } from 'react-redux'
import { selectRoadSegments } from '@/features/domain/roadSegment'

export const useHasRoadEdits = () => {
  const roadSegments = useSelector(selectRoadSegments)

  return Object.keys(roadSegments).length > 0
}
